import { useViewport } from '@cinch-labs/shared-util'
import { useEffect, useState } from 'react'

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(true)

  const { vw } = useViewport()

  useEffect(() => {
    const isNowMobile = vw < 1024

    if (isNowMobile !== isMobile) {
      setIsMobile(isNowMobile)
    }
  }, [vw])

  return { isMobile }
}

export default useIsMobile
